<template>
    <div class="base-config">
      <div class="page-header">
        <h2 class="page-title">基础设置</h2>
        <p class="page-desc">配置平台基础信息、分享设置、客服配置、协议内容等</p>
      </div>
  
      <div class="config-container">
        <el-tabs v-model="activeTab" type="border-card">
          <!-- 平台信息 -->
          <el-tab-pane label="平台信息" name="platform">
            <el-form :model="form" ref="formRef" label-width="120px">
              <el-form-item label="平台状态">
                <el-switch v-model="form.platform_status" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭" />
                <div class="form-tip">关闭后用户端将无法访问</div>
              </el-form-item>
  
              <el-form-item label="平台LOGO">
                <div class="upload-wrapper">
                  <el-upload :file-list="logoFileList" action="#" :limit="1" accept="image/*" :auto-upload="false"
                    :on-change="handleLogoChange" :on-remove="() => form.platform_logo = ''" list-type="picture-card">
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                  <div class="upload-tip">建议尺寸200x200px，支持JPG/PNG</div>
                </div>
              </el-form-item>
  
              <el-form-item label="平台名称">
                <el-input v-model="form.platform_name" placeholder="请输入平台名称" maxlength="50" />
              </el-form-item>
  
              <el-form-item label="平台简介">
                <el-input v-model="form.platform_desc" type="textarea" :rows="3" placeholder="请输入平台简介" maxlength="200" show-word-limit />
              </el-form-item>
  
              <el-form-item label="所属行业">
                <el-select v-model="form.industry" placeholder="请选择行业" style="width: 300px" @change="onIndustryChange">
                  <el-option v-for="item in industryOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-input v-if="form.industry === 'custom'" v-model="form.industry_custom" placeholder="请输入自定义行业" style="width: 300px; margin-top: 10px;" />
              </el-form-item>
            </el-form>
          </el-tab-pane>
  
          <!-- 分享设置 -->
          <el-tab-pane label="分享设置" name="share">
            <el-form :model="form" label-width="120px">
              <el-form-item label="分享标题">
                <el-input v-model="form.share_title" placeholder="请输入分享标题" maxlength="50" show-word-limit />
                <div class="form-tip">用户分享时显示的标题</div>
              </el-form-item>
  
              <el-form-item label="分享简介">
                <el-input v-model="form.share_desc" type="textarea" :rows="3" placeholder="请输入分享简介" maxlength="200" show-word-limit />
                <div class="form-tip">用户分享时显示的描述文字</div>
              </el-form-item>
  
              <el-form-item label="分享图标">
                <div class="upload-wrapper">
                  <el-upload :file-list="shareIconFileList" action="#" :limit="1" accept="image/*" :auto-upload="false"
                    :on-change="handleShareIconChange" :on-remove="() => form.share_icon = ''" list-type="picture-card">
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                  <div class="upload-tip">建议尺寸200x200px，支持JPG/PNG</div>
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
  
          <!-- 客服配置 -->
          <el-tab-pane label="客服配置" name="customer">
            <el-form :model="form" label-width="140px">
              <el-form-item label="客服类型">
                <el-radio-group v-model="form.customer_type" @change="onCustomerTypeChange">
                  <el-radio value="none">无客服</el-radio>
                  <el-radio value="wxwork">企业微信客服</el-radio>
                  <el-radio value="wxgzh">微信公众号客服</el-radio>
                  <el-radio value="normal">普通客服</el-radio>
                </el-radio-group>
              </el-form-item>
  
              <template v-if="form.customer_type === 'wxwork'">
                <el-form-item label="企业ID">
                  <el-input v-model="form.wxwork_corp_id" placeholder="请输入企业微信企业ID" />
                </el-form-item>
                <el-form-item label="客服AgentId">
                  <el-input v-model="form.wxwork_agent_id" placeholder="请输入客服AgentId" />
                </el-form-item>
                <el-form-item label="客服Secret">
                  <el-input v-model="form.wxwork_secret" type="password" placeholder="请输入客服Secret" show-password />
                </el-form-item>
              </template>
  
              <template v-if="form.customer_type === 'wxgzh'">
                <el-form-item label="公众号AppID">
                  <el-input v-model="form.wxgzh_appid" placeholder="请输入微信公众号AppID" />
                </el-form-item>
                <el-form-item label="公众号Secret">
                  <el-input v-model="form.wxgzh_secret" type="password" placeholder="请输入微信公众号Secret" show-password />
                </el-form-item>
              </template>
  
              <template v-if="form.customer_type === 'normal'">
                <el-form-item label="客服二维码">
                  <div class="upload-wrapper">
                    <el-upload :file-list="normalQrcodeFileList" action="#" :limit="1" accept="image/*" :auto-upload="false"
                      :on-change="handleNormalQrcodeChange" :on-remove="() => form.normal_qrcode = ''" list-type="picture-card">
                      <el-icon><Plus /></el-icon>
                    </el-upload>
                    <div class="upload-tip">请上传客服微信二维码</div>
                  </div>
                </el-form-item>
                <el-form-item label="客服手机号">
                  <el-input v-model="form.normal_phone" placeholder="请输入客服手机号" />
                </el-form-item>
              </template>
            </el-form>
          </el-tab-pane>
  
          <!-- 服务协议 -->
          <el-tab-pane label="服务协议" name="service">
            <el-form :model="form" label-width="120px">
              <el-form-item label="协议名称">
                <el-input v-model="form.service_agreement_name" placeholder="请输入服务协议名称" maxlength="50" />
              </el-form-item>
              <el-form-item label="协议内容">
                <div class="editor-wrapper">
                  <QuillEditor ref="serviceQuillRef" v-model:content="form.service_agreement_content" contentType="html"
                    :options="editorOptions" style="height: 400px" />
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
  
          <!-- 隐私协议 -->
          <el-tab-pane label="隐私协议" name="privacy">
            <el-form :model="form" label-width="120px">
              <el-form-item label="协议名称">
                <el-input v-model="form.privacy_agreement_name" placeholder="请输入隐私协议名称" maxlength="50" />
              </el-form-item>
              <el-form-item label="协议内容">
                <div class="editor-wrapper">
                  <QuillEditor ref="privacyQuillRef" v-model:content="form.privacy_agreement_content" contentType="html"
                    :options="editorOptions" style="height: 400px" />
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
  
        <div class="save-footer">
          <el-button type="primary" @click="saveConfig" :loading="submitting" size="large" class="save-btn">
            <el-icon><Check /></el-icon>保存所有配置
          </el-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import Cookies from 'js-cookie'
  import axios from 'axios'
  import config from '@/config'
  import { getUploadSignature, uploadToOSS } from '@/utils/uploadUtils'
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'
  import { Plus, Check } from '@element-plus/icons-vue'
  
  export default {
    name: 'BaseConfig',
    components: { QuillEditor, Plus, Check },
    setup() {
      const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
      const storeId = ref(userInfo.id || 0)
      const agentId = ref(userInfo.agent_id || 0)
  
      const activeTab = ref('platform')
      const formRef = ref(null)
      const serviceQuillRef = ref(null)
      const privacyQuillRef = ref(null)
      const submitting = ref(false)
  
      const logoFileList = ref([])
      const shareIconFileList = ref([])
      const normalQrcodeFileList = ref([])
  
      const industryOptions = [
        { value: 'catering', label: '餐饮美食' },
        { value: 'retail', label: '零售百货' },
        { value: 'beauty', label: '美容美发' },
        { value: 'hotel', label: '酒店住宿' },
        { value: 'entertainment', label: '休闲娱乐' },
        { value: 'education', label: '教育培训' },
        { value: 'medical', label: '医疗健康' },
        { value: 'custom', label: '自定义' }
      ]
  
      const form = reactive({
        platform_status: 1,
        platform_logo: '',
        platform_name: '',
        platform_desc: '',
        industry: '',
        industry_custom: '',
        share_title: '',
        share_desc: '',
        share_icon: '',
        customer_type: 'none',
        wxwork_corp_id: '',
        wxwork_agent_id: '',
        wxwork_secret: '',
        wxgzh_appid: '',
        wxgzh_secret: '',
        normal_qrcode: '',
        normal_phone: '',
        service_agreement_name: '',
        service_agreement_content: '',
        privacy_agreement_name: '',
        privacy_agreement_content: ''
      })
  
      const editorOptions = {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
            handlers: {
              image: function () {
                const input = document.createElement('input')
                input.setAttribute('type', 'file')
                input.setAttribute('accept', 'image/*')
                input.click()
                input.onchange = async () => {
                  const file = input.files[0]
                  if (!file) return
                  const loading = ElLoading.service({ text: '上传图片中...', background: 'rgba(0, 0, 0, 0.7)' })
                  try {
                    const range = this.quill.getSelection(true)
                    const url = await uploadImage(file)
                    this.quill.insertEmbed(range.index, 'image', url)
                    this.quill.setSelection(range.index + 1)
                    ElMessage.success('图片上传成功')
                  } catch (error) {
                    console.error('上传失败:', error)
                    ElMessage.error(error.message || '图片上传失败')
                  } finally {
                    loading.close()
                  }
                }
              }
            }
          }
        },
        placeholder: '请输入协议内容...',
        theme: 'snow'
      }
  
      const uploadImage = async (file) => {
        if (!file.type.startsWith('image/')) {
          throw new Error('只能上传图片文件')
        }
        if (file.size / 1024 / 1024 > 5) {
          throw new Error('图片大小不能超过 5MB')
        }
        const signature = await getUploadSignature('image')
        const ossRes = await uploadToOSS(file, signature)
        return ossRes.url
      }
  
      const uploadSingleImage = async (file, field) => {
        if (!file.type.startsWith('image/')) {
          ElMessage.error('只能上传图片文件')
          return null
        }
        if (file.size / 1024 / 1024 > 5) {
          ElMessage.error('图片大小不能超过 5MB')
          return null
        }
        try {
          const signature = await getUploadSignature('image')
          const ossRes = await uploadToOSS(file, signature)
          form[field] = ossRes.url
          return ossRes.url
        } catch (error) {
          console.error('上传失败:', error)
          ElMessage.error('上传失败')
          return null
        }
      }
  
      const handleLogoChange = async (file) => {
        if (!file.raw) return
        const url = await uploadSingleImage(file.raw, 'platform_logo')
        if (url) {
          logoFileList.value = [{ uid: file.uid, name: file.name, url }]
          ElMessage.success('上传成功')
        }
      }
  
      const handleShareIconChange = async (file) => {
        if (!file.raw) return
        const url = await uploadSingleImage(file.raw, 'share_icon')
        if (url) {
          shareIconFileList.value = [{ uid: file.uid, name: file.name, url }]
          ElMessage.success('上传成功')
        }
      }
  
      const handleNormalQrcodeChange = async (file) => {
        if (!file.raw) return
        const url = await uploadSingleImage(file.raw, 'normal_qrcode')
        if (url) {
          normalQrcodeFileList.value = [{ uid: file.uid, name: file.name, url }]
          ElMessage.success('上传成功')
        }
      }
  
      const onIndustryChange = () => {
        if (form.industry !== 'custom') {
          form.industry_custom = ''
        }
      }
  
      const onCustomerTypeChange = () => {
        // 清空其他客服类型的配置
        if (form.customer_type !== 'wxwork') {
          form.wxwork_corp_id = ''
          form.wxwork_agent_id = ''
          form.wxwork_secret = ''
        }
        if (form.customer_type !== 'wxgzh') {
          form.wxgzh_appid = ''
          form.wxgzh_secret = ''
        }
        if (form.customer_type !== 'normal') {
          form.normal_qrcode = ''
          form.normal_phone = ''
        }
      }
  
      const fetchConfig = async () => {
        const loading = ElLoading.service({ text: '加载中...' })
        try {
          const res = await axios.get(`${config.BASE_URL}/shop/api/base_config_api.php`, {
            params: { store_id: storeId.value, agent_id: agentId.value }
          })
          if (res.data.code === 200 && res.data.data) {
            Object.assign(form, res.data.data)
            
            // 恢复图片预览
            if (form.platform_logo) {
              logoFileList.value = [{ uid: Date.now(), name: 'logo', url: form.platform_logo }]
            }
            if (form.share_icon) {
              shareIconFileList.value = [{ uid: Date.now(), name: 'share_icon', url: form.share_icon }]
            }
            if (form.normal_qrcode) {
              normalQrcodeFileList.value = [{ uid: Date.now(), name: 'qrcode', url: form.normal_qrcode }]
            }
          }
        } catch (err) {
          console.error(err)
          ElMessage.error('获取配置失败')
        } finally {
          loading.close()
        }
      }
  
      const saveConfig = async () => {
        submitting.value = true
        const loading = ElLoading.service({ text: '保存中...' })
  
        try {
          const payload = {
            store_id: storeId.value,
            agent_id: agentId.value,
            platform_status: form.platform_status,
            platform_logo: form.platform_logo,
            platform_name: form.platform_name,
            platform_desc: form.platform_desc,
            industry: form.industry,
            industry_custom: form.industry_custom,
            share_title: form.share_title,
            share_desc: form.share_desc,
            share_icon: form.share_icon,
            customer_type: form.customer_type,
            wxwork_corp_id: form.wxwork_corp_id,
            wxwork_agent_id: form.wxwork_agent_id,
            wxwork_secret: form.wxwork_secret,
            wxgzh_appid: form.wxgzh_appid,
            wxgzh_secret: form.wxgzh_secret,
            normal_qrcode: form.normal_qrcode,
            normal_phone: form.normal_phone,
            service_agreement_name: form.service_agreement_name,
            service_agreement_content: form.service_agreement_content,
            privacy_agreement_name: form.privacy_agreement_name,
            privacy_agreement_content: form.privacy_agreement_content
          }
          
          const res = await axios.post(`${config.BASE_URL}/shop/api/base_config_api.php`, payload)
  
          if (res.data.code === 200) {
            ElMessage.success('保存成功')
          } else {
            ElMessage.error(res.data.message || '保存失败')
          }
        } catch (err) {
          console.error(err)
          ElMessage.error('保存失败')
        } finally {
          submitting.value = false
          loading.close()
        }
      }
  
      onMounted(() => {
        fetchConfig()
      })
  
      return {
        activeTab,
        form,
        formRef,
        serviceQuillRef,
        privacyQuillRef,
        submitting,
        logoFileList,
        shareIconFileList,
        normalQrcodeFileList,
        industryOptions,
        editorOptions,
        handleLogoChange,
        handleShareIconChange,
        handleNormalQrcodeChange,
        onIndustryChange,
        onCustomerTypeChange,
        saveConfig
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .base-config {
    .page-header {
      margin-bottom: 24px;
  
      .page-title {
        font-size: 24px;
        font-weight: 600;
        color: #1a1a2e;
        margin-bottom: 4px;
      }
  
      .page-desc {
        font-size: 14px;
        color: #8c8c8c;
      }
    }
  
    .config-container {
      background: #fff;
      border-radius: 16px;
      overflow: hidden;
    }
  
    .form-tip {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
      margin-left: 5px;
      line-height: 1.4;
    }
  
    .upload-tip {
      font-size: 12px;
      color: #8c8c8c;
      margin-top: 8px;
    }
  
    .editor-wrapper {
      width: 100%;
  
      :deep(.ql-toolbar) {
        border-radius: 8px 8px 0 0;
      }
  
      :deep(.ql-container) {
        border-radius: 0 0 8px 8px;
        min-height: 300px;
      }
    }
  
    .save-footer {
      padding: 20px;
      text-align: center;
      border-top: 1px solid #f0f0f0;
    }
  
    .save-btn {
      padding: 10px 32px;
      font-size: 16px;
      font-weight: 500;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
      border: none !important;
    }
  }
  </style>